<template>
  <div>
    <thux-table
      :instance="instance"
      :instance-name="instanceName"
      :order-by-dict="orderByDict"
      :goBack="goBack"
      :list="list"
      :fieldName="fieldName"
      :fields="fields"
      :fields-column="fieldsColumn"
      :select-all="selectAll"
      :selected-list="selectedList"
      :get-local-selected-all="getLocalSelectedAll"
      :local-selected-list="localSelectedList"
      @check-all="checkAll('id')"
      @check-none="checkNone('id')"
      @set-selected-row="setSelectedRow($event, 'id')"
      :show-checks="showChecks"
      :showDetailButton="showDetailButton"
      @change-status="changeInstanceStatus"
      @sort-changed="orderTable"
      @remove-order-by="removeOrderFromTable"
      @open-detail-form="goToDetail($event)"
    >
      <template slot="status_name" slot-scope="row">
        <span :class="`fw-600 tag tag-${DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS[row.item.status]}`">
          {{row.item.status_name}}
        </span>
      </template>
      <template slot="date_start" slot-scope="row">
        {{ row.item.date_start | date}}
      </template>
      <template slot="date_end" slot-scope="row">
        <span :class="row.item.is_document_expired ? 'text-red' : ''">
          {{ row.item.date_end | date}}
        </span>
      </template>
      <template slot="other-buttons-actions-bottom" slot-scope="row">
        <b-btn v-if="row.item.attachment"
          v-has-perms="['document_uploaddocument_download_attachment']"
          variant="outline-primary"
          :title="'download' | translate"
          @click="downloadDocument(row.item)"
        >
          <i class="fas fa-download"></i>
        </b-btn>
        <b-btn
          v-has-perms="['document_uploaddocument_list']"
          variant="outline-primary"
          size="sm"
          :title="`${$t(`Contact's documents`)} ${$t(instanceName)}`"
          @click="goToOrganizationDocuments(row)"
        >
          <i
            :title="`${$t(`Contact's documents`)} ${$t(instanceName)}`"
            class="far fa-file-alt"
          />
        </b-btn>
      </template>
    </thux-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin.vue'
import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin.vue'
import { DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS, ORGANIZATION_CUSTOMER_CODE, ORGANIZATION_SUPPLIER_CODE, ORGANIZATION_CUSTOMER_LEAD_CODE } from '../../../const'
import { TYPES as TRAINING_TYPES } from './store'

// import { ROUTES as CUSTOMER_ORG_ROUTES } from '../../organization/organization/organization/customer-organization/router'
// import { ROUTES as LEAD_ORG_ROUTES } from '../../organization/organization/organization/lead-organization/router'
// import { ROUTES as SUPPLIER_ORG_ROUTES } from '../../organization/organization/organization/supplier-organization/router'

import { ROUTES as CUSTOMER_CONTACT_ROUTES } from '../../organization/contact/contact/customer-contact/router'
import { ROUTES as SUPPLIER_CONTACT_ROUTES } from '../../organization/contact/contact/supplier-contact/router'
import { ROUTES as LEAD_CONTACT_ROUTES } from '../../organization/contact/contact/lead-contact/router'

export default {
  name: 'TrainingTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS,
      fields: [
        {
          key: 'status_name',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          custom: true
        },
        {
          key: 'worker__first_name',
          label: this.$t('Worker'),
          thClass: 'text-nowrap',
          tdClass: 'text-wrap',
          sortable: true,
          value: 'worker_full_name'
        },
        {
          key: 'worker__organizations__name',
          label: this.$t('Organizations'),
          thClass: 'text-nowrap',
          tdClass: 'text-wrap',
          sortable: true,
          value: 'worker_organizations'
        },
        {
          key: 'date_start',
          label: this.$t('Validity start'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'date_end',
          label: this.$t('Validity end'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: [],
      fieldName: 'id',
      showDocumentHistoryModal: false
    }
  },
  computed: {
    ...mapGetters({
      selectAll: TRAINING_TYPES.GENERIC.dashboard.training.LIST.GETTERS.selectAll,
      selectedList: TRAINING_TYPES.GENERIC.dashboard.training.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return false
    }
  },
  methods: {
    ...mapMutations({
      setList: TRAINING_TYPES.GENERIC.dashboard.training.LIST.MUTATIONS.setList,
      setSelectedList:
        TRAINING_TYPES.GENERIC.dashboard.training.LIST.MUTATIONS.setSelectedList,
      setSelectAll: TRAINING_TYPES.GENERIC.dashboard.training.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TRAINING_TYPES.GENERIC.dashboard.training.LIST.ACTIONS
    }),
    goToOrganizationDocuments (data) {
      const params = { cntId: data.item.worker, orgType: data.item.default_org_type_code }
      switch (data.item.default_org_type_code) {
        case ORGANIZATION_CUSTOMER_CODE:
          return this.$router.push({ name: CUSTOMER_CONTACT_ROUTES.CUSTOMER_CONTACT_DOCUMENT_LIST, params })
        case ORGANIZATION_SUPPLIER_CODE:
          return this.$router.push({ name: SUPPLIER_CONTACT_ROUTES.SUPPLIER_CONTACT_DOCUMENT_LIST, params })
        case ORGANIZATION_CUSTOMER_LEAD_CODE:
          return this.$router.push({ name: LEAD_CONTACT_ROUTES.LEAD_CONTACT_DOCUMENT_LIST, params })
      }
    },
    downloadDocument (item) {
      const fileName = `${item.document_name}.${item.attachment_simple_filename.split('.').pop()}`
      this.download({ id: item.id, action: 'download-attachment', simpleFileName: fileName })
    }
  }
}
</script>
